import commonService from "./common-service";

class MedPassService {
  async getEmarPatients(query, med_pas_id) {

    try {
      const response = await commonService.postToServer("EMar/Patients?"  + query, med_pas_id);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async postKOPQtyValidation(fil_id, qty) {

    try {
      const response = await commonService.getFromServer("EMar/kopQtyValidation?fil_id="  + fil_id + "&qty_given=" + qty, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async CheckKOPReAdministerStatus(id, ) {

    try {
      const response = await commonService.getFromServer("EMar/IsReAdministrable?administration_id="  +id, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getEmarActiveOrders(date, pat_id, ranges) {

    try {
      const response = await commonService.postToServer("EMar/GetPatientActiveOrders?date="  + date + "&pat_id=" + pat_id, ranges);
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getEmarPatientMedStats(date, pat_id, fac_id) {

    try {
      const response = await commonService.postToServer("EMar/GetPatientMedStats?date="  + date + "&pat_id=" + pat_id + "&fac_id=" + fac_id, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getKOPPatients(query) {
    try {
      const response = await commonService.postToServer("EMar/KopPatients?" +query, {});

      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getKOPPatientMedications(date, patId, facId) {
    try {
      const response = await commonService.postToServer("EMar/GetKopPatientMedications?date=" + date + "&pat_id=" + patId + "&fac_id=" + facId, {});

      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitKOPMedication(params) {
    try {
      var response = await commonService.postToServer(
        "EMar/KopPatientMedications",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDefaults(facId) {
    try {
      let response = await commonService.getFromServer("EMar/Defaults?fac_id=" + facId);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getReasonsTypes(facId) {
    try {
      let response = await commonService.getFromServer("EMar/ReasonTypes?fac_id=" + facId);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getReasons(facId) {
    try {
      let response = await commonService.getFromServer("EMar/Reasons?fac_id=" + facId);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async deletedReasons(id) {
    try {
      let response = await commonService.deleteToServer("EMar/Reason?id=" + id);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async addReason(params) {
    try {
      let response = await commonService.postToServer("EMar/Reason", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getRanges(facId) {
    try {
      let response = await commonService.getFromServer("EMar/Ranges?fac_id=" + facId);
      
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async deletedRange(id) {
    try {
      let response = await commonService.deleteToServer("EMar/Range?id=" + id);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async addRange(params) {
    try {
      let response = await commonService.postToServer("EMar/Range" , params);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getEndPass(date, range_id) {
    try {
      let response = await commonService.getFromServer("EMar/EndPass?med_date=" + date + "&range_id=" + range_id);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async submitEndMedpass(params) {
    try {
      const response = await commonService.postToServer(
        "EMar/EndPass",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async postOnHold(params) {
    try {
      const response = await commonService.postToServer(
        "EMar/MedpassStatus",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getPatientMedications(date, patId, range_id) {
    try {
      const response = await commonService.postToServer("EMar/GetPatientMedications?date=" + date + "&pat_id=" + patId , range_id);
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async submitMedication(params) {
    try {
      var response = await commonService.postToServer(
        "EMar/PatientMedications",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getDrugs(fac_id) {
    try {
      let response = await commonService.getFromServer("EMar/MedStats/"+fac_id);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
 
  async getEmarPatientInfo(facId, date) {
    try {
      const response = await commonService.getFromServer("EMar/PatientsList?fac_id=" + facId + "&date=" + date, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getEmarPatientHistoryInfo(facId, patId, date) {
    try {
      const response = await commonService.getFromServer("EMar/PatientMedicationHistory?fac_id=" + facId + "&pat_id=" + patId + "&date=" + date, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async deleteMedsGivenToday(id) {
    try {
      let response = await commonService.deleteToServer("EMar/DeleteStatMed?id=" + id);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getKOPPatientsBySearch(query) {
    try {
      const response = await commonService.getFromServer("EMar/KopPatientsList?" + query, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
export default new MedPassService();
